import { setupBlock } from "./setup-block";
import { getBoolFromParams } from "@firesim/simkit-core";

import type { Config } from "./config";

export const config: Config = {
    planeData: "data/tiwi.json",
    backgroundImage: "images/tiwi/tiwiislands3.jpg",
    backgroundColor: "#d69061"
};

export const overheadConfig: Config = {
    planeData: "data/tiwi-overhead.json",
    backgroundImage: "images/tiwi/tiwi-overhead.png",
    backgroundColor: "#d69061",
};

const useOverhead = getBoolFromParams('overhead');


setupBlock(useOverhead ? overheadConfig : config);
